export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window === "undefined") {
        return;
    }

    if (typeof window.gtag === "function") {
        window.gtag("event", eventName, eventParams);
    } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...eventParams });
    }
};

export const trackFacebookEvent = (eventName, eventParams = {}) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", eventName, eventParams);
    }
};
